<div class="share-sales-detail">
    <image-carousel class="image-carousel" [imagePackages]="imagePackages()" estateType="Flat"></image-carousel>
    <div class="first-detail-area">
        <key-value-pair-list [keyValuePairs]="firstColumnKeyValuePairs()" [enableShowMore]="true"></key-value-pair-list>
    </div>
    <div class="second-detail-area">
        <key-value-pair-list [keyValuePairs]="secondColumnKeyValuePairs()" [enableShowMore]="true"></key-value-pair-list>
    </div>
</div>
<div class="link-area">
    @let adData = data();
    @if (hasValueAssessmentPermission()) {
        <a
            class="link-button"
            target="_blank"
            [routerLink]="['/resolve/valuateEstate']"
            [queryParams]="{ estateId: adData.estateId, estateShareId: adData.estateShareId, addressId: adData.addressId }"
        >
            Åpne i Verdiassistent
        </a>
    }
    @if (adData.hasAdText) {
        <a [href]="adData.prospectUrl" target="_blank" rel="noopener noreferrer" class="link-with-icon">
            <span class="main-link-item prospect"></span>Se prospekt
        </a>
    }
    @if (adData.sourceUrl) {
        <a [href]="adData.sourceUrl" target="_blank" rel="noopener noreferrer" class="link-with-icon">
            <span class="main-link-item finn"></span>Se Finn-annonse
        </a>
    }
    @if (adData.sourceUrl_Hjem) {
        <a [href]="adData.sourceUrl_Hjem" class="link-with-icon" target="_blank" rel="noopener noreferrer">
            <span class="main-link-item hjem"></span> Se Hjem-annonse
        </a>
    }
</div>
